import { ApiEndpoints } from "@shared/api/api-endpoints";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";

export const uxSharedApi = {
  getChoices: async (
    name: string,
    remoteUtilityId: string,
    context?: string
  ) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `choices/${name}`,
      (query) => {
        query.push("remote_utility_id", remoteUtilityId);
        if (context) {
          query.push("context", context);
        }
        return query;
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data;
  },

  getWorkflowsData: async (id: any, name: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `${name}/${id}/workflows`,
      (query) => {
        query.push("remote_utility_id", getRemoteUtilityId());
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
getNotes: async (id: string, type: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `notes`,
      (query) => {
        query.push("remote_utility_id", getRemoteUtilityId());
        query.push("entity_type", type);
        query.push("entity_id", id);
        return query;
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },

  createNote: async (payload: any): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters("communication", "notes");
    const response = await communicationApiClient.post(url, payload);
    return response.data;
  },

  getActivityLog: async (id: string, type: string) => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      "communication",
      `activity-log`,
      (query) => {
        query.push("remote_utility_id", getRemoteUtilityId());
        query.push("patient_id", id);
        query.push("entity_type", type);
        return query;
      }
    );
    const response = await communicationApiClient.get(url);
    return response.data ?? [];
  },
};
